import React from "react";
import {AnimatePresence} from "framer-motion";

export function TracksContainer({children}) {
    return <ul style={{
        listStyle: "none",
        padding: 0,
        margin: 0,
        display: "flex",
        flexDirection: "column",
        position: "relative",
        width: "100%"}
    }>
        <AnimatePresence initial={false}>
        {children}
        </AnimatePresence>
    </ul>
}
